"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslationsWithNamespaces = void 0;
var _react = require("react");
var _translationsContext = require("../translationsContext");
var _utils = require("../utils");
/**
 * Represents the result of using translations with namespaces.
 *
 * @typeParam T Type of the translations object.
 */

/**
 * Custom hook for accessing all translations with namespaces provided to TranslationsProvider.
 *
 * @typeParam T Type of the translations object.
 * @returns Object which contains translations and related information.
 */

const useTranslationsWithNamespaces = () => {
  const {
    translationsWithNamespaces,
    currentLanguage,
    language,
    defaultTranslationsWithNamespaces,
    showTranslationKeys
  } = (0, _react.useContext)(_translationsContext.translationsContext);
  const usedTranslationsWithNamespaces = translationsWithNamespaces ? translationsWithNamespaces : defaultTranslationsWithNamespaces;
  return (0, _react.useMemo)(() => ({
    translationsWithNamespaces: showTranslationKeys ? Object.fromEntries(Object.entries(usedTranslationsWithNamespaces).map(([namespace, translations]) => [namespace, (0, _utils.mapTranslationsToKeys)(translations, namespace)])) : usedTranslationsWithNamespaces,
    currentLanguage: currentLanguage ?? '',
    language: language ?? ''
  }), [language, currentLanguage, usedTranslationsWithNamespaces, showTranslationKeys]);
};
exports.useTranslationsWithNamespaces = useTranslationsWithNamespaces;
